export default "/_next/static/images/e3276d57df76bb8d66e119ceff11c9b5.jpg";